module.exports = __webpack_public_path__ + "static/media/group-1@2x.827b689f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group-1@2x.png
// module id = 580
// module chunks = 1